export default "__VITE_ASSET__DcwBG_i6__"